export var AppMode = /*#__PURE__*/function (AppMode) {
  AppMode["LOADING"] = "LOADING";
  AppMode["DEFAULT_MOP"] = "DEFAULT_MOP";
  AppMode["LIST_MOPS"] = "LIST_MOPS";
  AppMode["EDIT"] = "EDIT";
  AppMode["ADD"] = "ADD";
  AppMode["VERIFY_3RD_PARTY_ADDRESS"] = "VERIFY_3RD_PARTY_ADDRESS";
  AppMode["YIFTEE_FULL_COVERAGE"] = "YIFTEE_FULL_COVERAGE";
  AppMode["REVIEW_MOP"] = "REVIEW_MOP";
  return AppMode;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/AppModeState/AppModeState.types.js
// module id = 102
// module chunks = 11